export default function ReflectionCard({ reflections = [] }) {
  return (
    <div className="rtv2-card">
      <div className="rtv2-card-head">
        <div>
          <h3>Reflection <em>— in your words</em></h3>
          <span className="sub">4 prompts · auto-saved</span>
        </div>
      </div>
      <div className="rtv2-reflection-grid">
        {reflections.map((r) => (
          <div key={r.key} className={`rtv2-reflection-item ${r.key}`}>
            <div className="tag">{r.title}</div>
            <p>{r.body}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
